import React from 'react';
import dayjs from 'dayjs';
import { convertCurrency } from 'utils/general';

import DateTimeIcon from 'assets/images/calendar/icon-datetime.svg';
import AlertIcon from 'assets/images/calendar/icon-alert.svg';
import AmountDueIcon from 'assets/images/calendar/icon-amount-due.svg';
import ProjectIcon from 'assets/images/calendar/icon-project.svg';
import ServiceTypeIcon from 'assets/images/calendar/icon-service-type.svg';
import VendorIcon from 'assets/images/calendar/icon-vendor.svg';

const PaymentEventCard = ({ eventDetails, project, userDetails }) => {
  const {
    id: paymentId,
    extendedProps = {},
  } = eventDetails || {};
  // TODO: We will return to these later
  // They should be provided with a more consistent pattern
  // const { image306 } = project || {};
  const { dateFormat } = userDetails || {};

  const {
    weddingId: projectId,
    weddingName = '',
    vendorName = '',
    vendorCategories = [],
    dependsOnFinalGuestCount: isPendingFinalGuestCount = false,
    dueDate = null,
    paidOn = null,
    amount = null,
    weddingCurrency = 'USD',
    invoicePayments = [],
  } = extendedProps;

  const dueDateFormatted = dueDate ? dayjs(dueDate).format(dateFormat) : null;
  const paidOnFormatted = paidOn ? dayjs(paidOn).format(dateFormat) : null;

  const paymentIndex = (() => {
    const index = invoicePayments.findIndex(p => p.id === Number(paymentId));
    return (index !== -1) ? index + 1 : null;
  })();
  const paymentTotal = invoicePayments?.length || 0;

  const showPaymentInfo = amount !== null && paymentIndex && paymentTotal > 0;
  const formattedAmount = amount !== null ? convertCurrency(amount, weddingCurrency) : '-';

  return (
    <div className="event-card info-card">
      <div className="info-card__content">
        <div className="info-card__row">
          <div className="info-card__title ap-text">
            Vendor Payment Due
          </div>
        </div>

        <div className="info-card__row">
          <div className="info-card__icon-wrapper">
            <img
              className="info-card__icon"
              src={ProjectIcon}
              alt="service type icon"
            />
          </div>
          <div>{weddingName || '-'}</div>
        </div>

        <div className="info-card__row">
          <div className="info-card__icon-wrapper">
            <img
              className="info-card__icon"
              src={VendorIcon}
              alt="service type icon"
            />
          </div>
          <div>{vendorName || '-'}</div>
        </div>

        <div className="info-card__row">
          <div className="info-card__icon-wrapper">
            <img
              className="info-card__icon"
              src={ServiceTypeIcon}
              alt="service type icon"
            />
          </div>
          <div>
            {vendorCategories.length > 0
              ? vendorCategories.map(c => c.category).join(', ')
              : '-'
            }
          </div>
        </div>

        <div className="info-card__row">
          <div className="info-card__icon-wrapper">
            <img
              className="info-card__icon"
              src={AmountDueIcon}
              alt="service type icon"
            />
          </div>
          <div>
            {formattedAmount}
            {showPaymentInfo && ` (${paymentIndex} of ${paymentTotal} payments)`}
          </div>
        </div>

        <div className="info-card__row">
          <div className="info-card__icon-wrapper">
            <img
              className="info-card__icon"
              src={AlertIcon}
              alt="service type icon"
            />
          </div>
          <div>
            {isPendingFinalGuestCount ? 'Pending Final Guest Count' : '-'}
          </div>
        </div>

        <div className="info-card__row">
          <div className="info-card__icon-wrapper">
            <img
              className="info-card__icon"
              src={DateTimeIcon}
              alt="date-time icon"
            />
          </div>
          <div>
            {paidOn ? `Paid on ${paidOnFormatted}` : `Due on ${dueDateFormatted}`}
          </div>
        </div>
      </div>

      {projectId && (
        <a
          className="button button--sm"
          href={`/app/project/${projectId}/tools/contacts`}
        >
          View Contact Record
        </a>
      )}
    </div>
  );
};

export default PaymentEventCard;
